import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonServices } from 'src/app/Common/CommonServices';
import { HostPortalClient, TimeSlot, User, WebinarRoomConfiguration, WebinarRoomOwnerDTO } from 'src/app/Services/WOWApi.Service';
import { MyConfigurationModel } from './my-configuration-model';
import { CustomServiceService } from 'src/app/Services/custom-service.service';
import { Subscription } from 'rxjs';
import { CommonService } from 'src/app/Services/common.service';
import { UpdateImageComponent } from '../update-image/update-image.component';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { formatTimeSlot, slotIcon as hostSlotIcon, slotToneFromLabel } from '../host-format';

@Component({
    selector: 'app-my-configuration',
    templateUrl: './my-configuration.component.html',
    styleUrls: ['./my-configuration.component.css'],
    standalone: false
})
export class MyConfigurationComponent implements OnInit, OnDestroy {
   
  timeSlots:TimeSlot[];
  maxItemSelectList:number[] = [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15]
  loggedUser: User; 
  dislayData:boolean=false;
  displayColumns: string[] = ['SlotTime', 'MaxItem', 'MaxItemsToSell'];
  displayNames: string[] = ['Queue Time I want to Use', 'Max Items for sale at once', 'Max Items to Sell during time period'];
  configurations:WebinarRoomConfiguration[];
  myConfigurationModel:MyConfigurationModel;
  myConfigurationData:MyConfigurationModel[];
  isMobileView = false;
  subscription: Subscription;
  roomImage: string;
  showRoomImage = false;
  @Input() hostRoom: WebinarRoomOwnerDTO[];
  selectedRoom: WebinarRoomOwnerDTO;
  confRoomControl = new UntypedFormControl('');
  constructor(private hostPortalClient:HostPortalClient,
    private commonServices: CommonServices
    , private customServices:CustomServiceService,private commonService: CommonService,
    private dialog: MatDialog
    ) { }

  ngOnInit(): void {
    if (this.hostRoom.length > 0) {
      this.confRoomControl.setValue(this.hostRoom[0]);
    }
    this.subscription = this.commonService.isMobileView.subscribe(res => this.isMobileView = res);
    this.loggedUser = this.customServices.GetLoggedInUser(); 
    this.GetData(this.hostRoom[0]);       
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();   
  }
GetData(room:WebinarRoomOwnerDTO) {
  this.selectedRoom = room;
  this.hostPortalClient.userConfiguration(this.selectedRoom.webinarRoomId).subscribe(configuration => {
    this.configurations = configuration;
    this.ProcessData(); 
}, error => {
  this.commonServices.showMessage('error', error, 5);
  this.configurations = undefined;
});
this.getRoomImage(this.selectedRoom.webinarRoomId);

}
  GetConfigurations(e)
  {
    this.GetData(e.value);
  }

  ProcessData()
  {
    this.myConfigurationData = [];
    this.myConfigurationModel = null;
    this.configurations.forEach(ele => {
       this.myConfigurationModel  = new MyConfigurationModel();
       this.myConfigurationModel.SlotTime = ele.timeSlot;
       this.myConfigurationModel.MaxItem = ele.maxItems;
       this.myConfigurationModel.MaxItemsToSell = ele.maxItems;
       this.myConfigurationData.push(this.myConfigurationModel);
    }); 
    this.dislayData = true;
  }
  GetDisplayName(index)
  {
    return this.displayNames[index];
  }
  UpdateMaxItem(value,SlotTime)
  {
    this.configurations.find(x => x.timeSlot ==SlotTime).maxItems = value;
  }
  
  Save()
  {
    this.hostPortalClient.saveConfiguration(this.configurations).subscribe(x => {
      this.commonServices.showMessage("Success", "Saved Successfully");

    });
  }

  onViewRoomImage() {
    this.showRoomImage = true;
  }

  closeRoomImage() {
    this.showRoomImage = false;
  }

  get roomImageSrc(): string | null {
    return this.roomImage ? `data:image/png;base64,${this.roomImage}` : null;
  }

  formatTimeSlot(slot?: string): string {
    return formatTimeSlot(slot);
  }

  slotTone(slot?: string, index = 0) {
    return slotToneFromLabel(slot, index);
  }

  slotIcon(slot?: string, index = 0): string {
    return hostSlotIcon(this.slotTone(slot, index));
  }

  onUpdateRoomImage() {
    this.dialog.open(UpdateImageComponent, {
      width: 'min(820px, 94vw)',
      maxHeight: '90vh',
      autoFocus: false,
      panelClass: 'host-config-dialog',
      data: {
        isRoomImageUpdate: true,
        roomId: this.selectedRoom.webinarRoomId,
        room: this.selectedRoom,
        roomImage: this.roomImage
      }
    }).afterClosed().subscribe(res => {
      if (res !== null && res.action == 'success') {
        this.getRoomImage(this.selectedRoom.webinarRoomId);
        this.selectedRoom.roomDescription = res.description;
      }
    });
  }

  getRoomImage(roomId: number) {
    this.customServices.GetRoomBussinessImage(roomId).subscribe(res => {
      this.roomImage = res;
    }, error => {
      this.commonServices.showMessage('error', error, 5);
      this.roomImage = undefined;
    });
  }

}
